import React from "react";
import "./App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider } from "./context/AuthContext";
import { NoiseOverlay } from "./components/NoiseOverlay";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import ProtectedRoute from "./components/ProtectedRoute";

import Home from "./pages/Home";
import Roster from "./pages/Roster";
import WrestlerDetail from "./pages/WrestlerDetail";
import Events from "./pages/Events";
import Championships from "./pages/Championships";
import News from "./pages/News";
import NewsDetail from "./pages/NewsDetail";
import Gallery from "./pages/Gallery";
import Media from "./pages/Media";
import Sponsors from "./pages/Sponsors";
import OpenRing from "./pages/OpenRing";
import OpenRingApply from "./pages/OpenRingApply";
import AdminLogin from "./pages/AdminLogin";
import AdminDashboard from "./pages/AdminDashboard";

const PublicLayout = ({ children }) => (
  <>
    <Navbar />
    <main className="pt-0">{children}</main>
    <Footer />
  </>
);

function App() {
  return (
    <div className="App">
      <NoiseOverlay />
      <Toaster theme="dark" position="top-right" richColors />
      <AuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<PublicLayout><Home /></PublicLayout>} />
            <Route path="/roster" element={<PublicLayout><Roster /></PublicLayout>} />
            <Route path="/roster/:id" element={<PublicLayout><WrestlerDetail /></PublicLayout>} />
            <Route path="/events" element={<PublicLayout><Events /></PublicLayout>} />
            <Route path="/championships" element={<PublicLayout><Championships /></PublicLayout>} />
            <Route path="/news" element={<PublicLayout><News /></PublicLayout>} />
            <Route path="/news/:id" element={<PublicLayout><NewsDetail /></PublicLayout>} />
            <Route path="/gallery" element={<PublicLayout><Gallery /></PublicLayout>} />
            <Route path="/media" element={<PublicLayout><Media /></PublicLayout>} />
            <Route path="/sponsors" element={<PublicLayout><Sponsors /></PublicLayout>} />
            <Route path="/openring" element={<PublicLayout><OpenRing /></PublicLayout>} />
            <Route path="/openring/apply" element={<PublicLayout><OpenRingApply /></PublicLayout>} />
            <Route path="/admin/login" element={<AdminLogin />} />
            <Route path="/admin" element={<ProtectedRoute><AdminDashboard /></ProtectedRoute>} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
